import { getAgentCompanyConfigA } from '../server/api'

const store = {
  namespaced: true,
  state: {
    company: {},
    access: {}
  },
  mutations: {
    SET_COMPANY(state, company) {
      state.company = company;
    },
    SET_PERMISSION(state, permission) {
      const adminAccessMap = {userSkill: 'userSkill', 'flow:llm': 'flowLlm', 'flowTextEditor': 'textEditor', 'flowImportExport': 'flowImportExport', 'flowAiGenerate': 'flowAiGenerate'}
      const defaultAccess = {}
      // 后台配置的权限
      const companyAccessConf = permission.c || {};
      // 代理商配置的权限
      const agentCompanyConf = permission.agentCompanyConf || {};
      // const userAccessConf = permission[currentUser?.id || ''] || {};
      // const roleAccessConf = permission[`r${currentUser?.role}`] || {};
      // [companyAccessConf, roleAccessConf, userAccessConf].forEach((accessConf) => {
      [companyAccessConf, agentCompanyConf].forEach((accessConf) => {
        Object.keys(accessConf).forEach((key) => {
          if (accessConf[key] === 'ignore' || !adminAccessMap[key]) return;
          if (accessConf[key] === 'enable') {
            defaultAccess[adminAccessMap[key]] = true;
            return;
          }
          if (accessConf[key] === 'disable') {
            defaultAccess[adminAccessMap[key]] = false;
            return;
          }
          if (accessConf[key]) defaultAccess[adminAccessMap[key]] = accessConf[key];
        });
      });
      state.access = defaultAccess
    }
  },
  actions: {
    setCompany({ commit }, company) {
      commit('SET_COMPANY', company);
    },
    async setPermission({ commit }, permission) {
      const agentCompanyConf = await getAgentCompanyConfigA()
        .then((res) => res.data?.permission?.agent || {})
        .catch(() => ({}));
      commit('SET_PERMISSION', { ...permission, agentCompanyConf })
    }
  }
}
export default store

